import { useState } from "react";
import { Modal } from "react-bootstrap";
import ModalComponentN5 from "../../components/Modal/ModalComponentN5";

export default function TableN5IGV({ data }) {
    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    return (
        <div>
            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Genes Records</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                CHROMOSOME NO
                            </th>
                            <th scope="col" className="font-monospace">
                                IRGSP-1.0
                            </th>
                            <th scope="col" className="font-monospace">
                                Type
                            </th>
                            <th scope="col" className="font-monospace">
                                Position Start
                            </th>
                            <th scope="col" className="font-monospace">
                                Position Stop
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data &&
                            data.length > 0 &&
                            data.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td scope="row" className="font-monospace">
                                            {item?.chromosome_no}
                                        </td>
                                        <td className="font-monospace">{item?.irgsp_1_0}</td>
                                        <td className="font-monospace">{item?.type}</td>
                                        <td className="font-monospace">{item?.position_start}</td>
                                        <td className="font-monospace">{item?.position_stop}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Genes Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN5 data={dataModal} />
                </Modal.Body>
            </Modal>
        </div>
    );
}
